'use strict';

const h = require('phy');
const ErrorSvg = require('@design-system/svg-icons/preact/Error').default;

const TraitsError = ({ showError, traitsErrorMsg }) => {
  if (showError) {
    return h(
      'div',
      {
        id: 'variation-error',
        className: 'error visible',
        'data-bhw': 'VariationsError',
        'data-bhc': 'error:variations-not-selected',
      },
      h(ErrorSvg),
      traitsErrorMsg
    );
  } else {
    return null;
  }
};

module.exports = TraitsError;
